import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { raiseWarningBanner } from 'components/MessageDispatch/messageDispatch';

export const Startup = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		raiseWarningBanner(
			<span>
				Our site has moved{' '}
				<a href='/' target='_top'>
					here
				</a>
				. Please update any bookmarks and references.
			</span>,
			dispatch
		);
	}, [dispatch]);
};
